import { Button, Grid, TextField } from '@mui/material'
import React from 'react'
import MainCard from 'ui-component/cards/MainCard'
import { IoMdArrowRoundBack } from "react-icons/io";
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import UpdateStatementTable from './UpdateStatementTable';
import { useState } from 'react';
import { useEffect } from 'react';
import { GetStatementStatus } from 'API/Limit_Topup_Checker/api';


const StatementStatus = (props) => {
    const formatDate = (date) => {
        const d = new Date(date);
        const year = d.getFullYear();
        const month = (d.getMonth() + 1).toString().padStart(2, '0');
        const day = d.getDate().toString().padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    const [FilterData, setFilterData] = useState({ uploaded_on: formatDate(new Date()), bank_name: "", page: 1 })
    const [StatementData, setStatementData] = useState(null)
    const [IsLoading, setIsLoading] = useState(false)



    const handleFilterChange = (event) => {
        if (event.target.name === "bank_name" && event.target.value === "select") {
            setFilterData({ ...FilterData, [event.target.name]: "" })
        }
        else {
            setFilterData({ ...FilterData, [event.target.name]: event.target.value })
        }
    }

    useEffect(() => {
        GetStatementStatus(FilterData.page, FilterData.uploaded_on, FilterData.bank_name, setIsLoading, setStatementData)
    }, [FilterData.page])










    return (
        <Grid container>
            <Grid item xl={12} lg={12} md={12} sm={12} xs={12} mb={1}>
                <MainCard>
                    <Button color='secondary' sx={{ fontSize: '18px' }} onClick={() => props.setViewStatementStatus(false)}><IoMdArrowRoundBack /></Button>
                    <Grid container p={2} gap={1} alignItems="center">
                        <Grid item xl={3} lg={3} md={4}>
                            <TextField
                                id="outlined-basic"
                                label="Statement from date"
                                type='date'
                                name="uploaded_on"
                                fullWidth
                                value={FilterData.uploaded_on ? FilterData.uploaded_on : ""}
                                onChange={handleFilterChange}
                                InputLabelProps={{
                                    shrink: true,

                                }}
                                inputProps={
                                    {
                                        max: formatDate(new Date()),
                                        onKeyDown: (e) => e.preventDefault(),
                                        style: {
                                            textAlign: 'left',
                                        }
                                    }
                                }
                                variant="outlined" />
                        </Grid>
                        <Grid item xl={3} lg={3} md={4}>
                            <FormControl fullWidth>
                                <InputLabel id="demo-simple-select-label">Beneficary bank</InputLabel>
                                <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    value={FilterData.bank_name ? FilterData.bank_name : "select"}
                                    name="bank_name"
                                    label="Beneficary bank"
                                    onChange={handleFilterChange}
                                >
                                    <MenuItem value={"select"}>Select</MenuItem>
                                    <MenuItem value={"SBI"}>SBI</MenuItem>
                                    <MenuItem value={"HDFC"}>HDFC</MenuItem>
                                    <MenuItem value={"ICICI"}>ICICI</MenuItem>
                                    <MenuItem value={"AXIS"}>AXIS</MenuItem>
                                    <MenuItem value={"BOB"}>BOB</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xl={2} lg={2}>
                            <Button disabled={IsLoading ? true : false} variant="contained" color="secondary" onClick={() => GetStatementStatus(FilterData.page, FilterData.uploaded_on, FilterData.bank_name, setIsLoading, setStatementData)}>Search</Button>
                        </Grid>
                    </Grid>
                </MainCard>
            </Grid>
            <Grid item xl={12} lg={12} md={12} xs={12}>
                <MainCard>
                    <UpdateStatementTable data={StatementData} FilterData={FilterData} setFilterData={setFilterData} IsLoading={IsLoading} />
                </MainCard>
            </Grid>
        </Grid>
    )
}

export default StatementStatus